'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  onSubmit: () => void
  onClose: () => void
}

const CancelShippingDeadlineExtensionModal = ({ isOpen, onSubmit, onClose }: Props) => {
  const translate = useTranslate('conversation.cancel_deadline_extension_modal')

  return (
    <Dialog
      title={translate('title')}
      body={translate('body')}
      testId="confirm-everything-is-ok-modal"
      actions={[
        {
          text: translate('actions.confirm'),
          style: Dialog.ActionStyling.Filled,
          callback: onSubmit,
          testId: 'cancel-deadline-extension-modal-confirm-button',
        },
        {
          text: translate('actions.cancel'),
          style: Dialog.ActionStyling.Flat,
          callback: onClose,
          testId: 'cancel-deadline-extension-modal-close-button',
        },
      ]}
      show={isOpen}
    />
  )
}

export default CancelShippingDeadlineExtensionModal
